export default __webpack_public_path__ + "static/media/background_mobile.ef412d0a.png";